import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-web-awesome-pro',
	templateUrl:'./WebAwesomeProPluginPage.html',
	styles: [],
	styleUrls:['./WebAwesomeProPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WebAwesomeProPluginPage
{
	mdContent_133 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>web-awesome-pro</artifactId>
</dependency>
\`\`\``;
	mdContent_134 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:web-awesome-pro:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_135 = `\`\`\`java
var page = new WaPage();
page.getHeader().add(new WaText<>().setText("My Application"));
page.getNavigation().add(buildMenuItems());
page.getMain().add(new RouterOutlet());
page.getFooter().add(new WaText<>().setText("2026 My Corp"));
\`\`\``;
	mdContent_136 = `\`\`\`java
var page = new WaPage();
page.getHeader().add(new WaText<>().setText("My App"));
page.getNavigation().add(menuItems);
page.getMain().add(content);
page.getFooter().add(footerContent);
\`\`\``;
}
